import React from 'react';
import { useParams } from 'react-router-dom';
import HomeschoolMain from './homeschool/HomeschoolMain';
import WmwMain from './churchschool/wmw/WmwMain';
import HFHJMain from './churchschool/hfhj/HFHJMain';

/**
 * SMS 문자 발송용 페이지 컴포넌트
 *
 * @description
 * - 문자 메시지로 전송되는 링크에서 사용되는 페이지
 * - URL 경로의 마지막 파라미터로 전달되는 UUID 값에 따라 다른 컴포넌트를 렌더링
 *
 * @param productSubType - 임의로 생성된 UUID 값 (DB 조회값이 아님)
 *   - 4b38faf7-3929-4356-b394-ca48f6b0b67c: 홈스쿨 메인
 *   - bd74a9c7-516b-4356-b8da-ab9412c7fe0e: WMW 메인
 *   - fb4d113c-72b0-482a-aadf-4f0155c460cf: HFHJ 메인
 */
const CourseDetail = () => {
  const productSubType = useParams().productSubType;

  switch (productSubType) {
    case '4b38faf7-3929-4356-b394-ca48f6b0b67c':
      return <HomeschoolMain />;
    case 'bd74a9c7-516b-4356-b8da-ab9412c7fe0e':
      return <WmwMain />;
    case 'fb4d113c-72b0-482a-aadf-4f0155c460cf':
      return <HFHJMain />;
    default:
      return <>잘못된 접속입니다.</>;
  }
};

export default CourseDetail;
